import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('bottom-nav')
export class BottomNav extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      background: #003366; /* Footer background color */
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
      border-radius: 20px 20px 0 0; /* Rounded top corners */
      z-index: 100;
      padding: 8px 16px;
      box-sizing: border-box;
    }

    nav {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
    }

    a {
      color: #e0e0e0; /* Light gray for text */
      text-decoration: none;
      font-size: 14px;
      text-align: center;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transition: color 0.3s, transform 0.3s;
    }

    a:hover {
      color: #b0b0b0; /* Darker gray on hover */
      transform: translateY(-4px);
    }

    .nav-icon {
      font-size: 24px;
      margin-bottom: 4px;
      transition: transform 0.3s;
      color: #e0e0e0; /* Uniform gray color for icons */
    }

    a:hover .nav-icon {
      transform: scale(1.2);
      color: #b0b0b0; /* Darker gray on hover */
    }

    /* Active state for links */
    a.active {
      color: #b0b0b0; /* Darker gray for active state */
    }

    /* Mobile Responsiveness */
    @media (max-width: 768px) {
      :host {
        padding: 3px 12px;
      }

      a {
        font-size: 12px;
      }

      .nav-icon {
        font-size: 22px;
      }
    }
  `;

  render() {
    return html`
      <nav>
        <a href="/home" class="nav-item">
          <span class="nav-icon">📅</span>
          <span>Calendar</span>
        </a>
        <a href="/statistics" class="nav-item">
          <span class="nav-icon">📊</span>
          <span>Statistics</span>
        </a>
        <a href="/settings" class="nav-item">
          <span class="nav-icon">📖</span>
          <span>Settings</span>
        </a>
      </nav>
    `;
  }
}
